import React, { useEffect, useState } from "react";
import { SectionContainer } from "../SectionContainer";
import { SubmenuControls } from "../SubmenuControls";

export const SocietalRisks = ({data, openMedia, selectedItem, onSelectItem}) => {
    return (
        <main className="main-container" aria-label="Zone de contenu principal">
            <div className="content">
                <SubmenuControls data={data} selectedItem={selectedItem} onSelectedItem={(itemId) => onSelectItem('risques-societaux', itemId)}/>
                <div className="subcontent">
                    <SectionContainer selectedItem={selectedItem} title={selectedItem.label} openMedia={openMedia}/>
                </div>
            </div>
        </main>
    )
}